import React, { Component } from 'react'
import { FloatingWhatsApp } from 'react-floating-whatsapp-button'
import { Button } from 'primereact/button';
import 'react-floating-whatsapp-button/dist/index.css'

export default function WhatsApp() {

    const link = "https://wa.me/573178006629?text=Hola,%20me%20gustaría%20recibir%20ayuda%20sobre%20MiRemuner"

    return (
        <div style={{ bottom: "0", right: "0", position: "fixed", marginBottom: "1rem", marginRight: "1rem", zIndex: "201" }}>
            <a style={{ textDecoration: "none" }} href={link} target="_blank" rel="noopener noreferrer">
                <Button icon="pi pi-whatsapp" className="p-button-rounded p-button-success" style={{borderRadius: '50px'}} aria-label="WhatsApp" tooltip='Resuelve tus dudas vía WhatsApp' tooltipOptions={{ position: "left" }} />
            </a>
        </div>
    )
}